import { render, staticRenderFns } from "./Diagram.vue?vue&type=template&id=c8b40168"
import script from "./Diagram.vue?vue&type=script&lang=ts"
export * from "./Diagram.vue?vue&type=script&lang=ts"
import style0 from "./Diagram.vue?vue&type=style&index=0&id=c8b40168&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports